import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';
import { IEditKidRequest } from '@/shared/interfaces';
import { R } from '@/Resources.resx';
import { unassociatedChildrenKeyAtom } from '@/features/shared/features/addOrEditChild/model/unassociatedChildrenAtom';
import { editChild } from '@/features/shared/features/addOrEditChild/api/editChild';

export const editChildMutationAtom = atomWithMutation((get) => ({
    mutationFn: async (variables: IEditKidRequest): Promise<string> => {
        return editChild(variables)
            .then((result) => {
                const queryClient = get(queryClientAtom);
                const unassociatedChildrenKey = get(
                    unassociatedChildrenKeyAtom,
                );
                queryClient.invalidateQueries({
                    queryKey: unassociatedChildrenKey,
                });
                return result;
            })
            .catch((error) => {
                // Modify the error message but still throw it for React Query to handle
                throw new Error(
                    `${R.CouldNotUpdateChild}${error instanceof Error ? error.message : R.UnknownError}`,
                );
            });
    },
}));
